export const renderAllTabsExperiment = 'specs.thunderbolt.render_all_tabs';
//# sourceMappingURL=constants.js.map